export const getTitolareEffettivoComponent = () => {
  const titolareEffettivo = {
    widgets: [
      // {
      //   code: '16727',
      //   name: 'TITOLARE_OWNER',
      //   bundleLink: null,
      //   bundleCode: null,
      //   position: 1,
      //   components: [
      //     {
      //       name: 'LABEL',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'label'
      //     },
      //     {
      //       name: 'EFFETTIVO_SI',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: ['selected'],
      //       type: 'radio'
      //     },
      //     {
      //       name: 'EFFETTIVO_NO',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'radio'
      //     }
      //   ],
      //   status: [],
      //   errorMessage: []
      // },
      {
        code: '16726',
        name: 'TITOLARE_DATA',
        bundleLink: null,
        bundleCode: null,
        position: 1,
        components: [
          {
            name: 'LABEL',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: 'label'
          },
          {
            name: 'EFFETTIVO_SI',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: ['selected'],
            type: 'radio'
          },
          {
            name: 'EFFETTIVO_NO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: 'radio'
          }
        ],
        status: [],
        errorMessage: []
      },
      {
        code: '16728',
        name: 'NOME_COGNOME',
        bundleLink: null,
        bundleCode: null,
        position: 2,
        components: [
          {
            name: 'COGNOME',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [''],
            values: [],
            type: null
          },
          {
            name: 'NOME',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [''],
            values: [],
            type: null
          }
        ],
        status: [],
        errorMessage: []
      },
      {
        code: '16729',
        name: 'CODICE_FISCALE',
        bundleLink: null,
        bundleCode: null,
        position: 3,
        components: [
          {
            name: 'CF',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [''],
            values: [],
            type: null
          },
          {
            name: 'DATADINASCITA',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [''],
            values: [],
            type: 'label'
          },
          {
            name: 'SESSO',
            value: '',
            rawValue: null,
            active: false,
            status: ['hidden'],
            errorMessage: [],
            validations: [''],
            values: [],
            type: 'label'
          },
          {
            name: 'PROVINCIADINASCITA',
            value: '',
            rawValue: null,
            active: false,
            status: ['hidden'],
            errorMessage: [],
            validations: [''],
            values: [],
            type: 'label'
          },
          {
            name: 'LUOGODINASCITA',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [''],
            values: [],
            type: 'label'
          }
        ],
        status: [],
        errorMessage: []
      },
      {
        code: '15865',
        name: 'RESIDENZA',
        bundleLink: null,
        bundleCode: null,
        position: 4,
        components: [
          {
            name: 'CAP',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['cap', 'required'],
            values: [],
            type: null
          },
          {
            name: 'CITTA',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required', 'city'],
            values: [],
            type: null
          },
          {
            name: 'INDIRIZZO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: null
          },
          {
            name: 'NAZIONE',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['word', 'required'],
            values: [
              {
                value: 'ABU DHABI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AFGHANISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AJMAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALAND ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALBANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALGERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANDORRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANGOLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANGUILLA (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANTARTIDE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANTIGUA E BARBUDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARABIA SAUDITA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARGENTINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARMENIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARUBA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ASCENSION',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AUSTRALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AUSTRIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AZERBAIGIAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AZZORRE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BAHAMAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BAHREIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BANGLADESH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BARBADOS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BELGIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BELIZE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BENIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BERMUDA (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BHUTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BIELORUSSIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOLIVIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BONAIRE SAINT EUSTATIUS AND SABA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOSNIA ED ERZEGOVINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOTSWANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOUVET ISOLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BRASILE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BRUNEI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BULGARIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BURKINA FASO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BURUNDI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAMBOGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAMERUN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CANADA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CANARIE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAPO VERDE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAROLINE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAYMAN (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CENTRAFRICANA REPUBBLICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CEUTA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHAFARINAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHAGOS ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHRISTMAS (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CIAD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CILE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CINA REPUBBLICA POPOLARE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CIPRO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CITTA DEL VATICANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CLIPPERTON',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COCOS (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COLOMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COMORE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CONGO REPUBBLICA DEMOCRATICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CONGO REPUBBLICA POPOLARE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COOK (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COREA DEL NORD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COREA DEL SUD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COSTA DAVORIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COSTA RICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CROAZIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CUBA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CURACAO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DANIMARCA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DOMINICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DUBAI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ECUADOR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'EGITTO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'EL SALVADOR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ERITREA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ESTONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ETIOPIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FAER OER (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FIGI=VITI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FILIPPINE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FINLANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FRANCIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FUIJAYRAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GABON',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GAMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GEORGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GERMANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GHANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIAMAICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIAPPONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIBILTERRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIBUTI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIORDANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GOUGH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GRECIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GRENADA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GROENLANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUADALUPA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUAM (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUATEMALA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUAYANA=GUIANA FRANCESE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUERNSEY ISOLE DEL CANALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA BISSAU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA EQUATORIALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUYANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HAITI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HEARD E MCDONALD ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HONDURAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HONG KONG',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'INDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'INDONESIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRAQ',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRLANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISLANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISOLE AMERICANE DEL PACIFICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISRAELE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ITALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'JERSEY ISOLE DEL CANALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KAZAKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KENYA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KIRGHIZISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KIRIBATI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KOSOVO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KUWAIT',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LA REUNION (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LAOS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LESOTHO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LETTONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIECHTENSTEIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LITUANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LUSSEMBURGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MACAO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MACEDONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MADAGASCAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MADEIRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALAWI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALAYSIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALDIVE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALTA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALVINE=FALKLAND (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAN (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARIANNE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAROCCO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARSHALL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARTINICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAURITANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAURIZIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAYOTTE (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MELILLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MESSICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MICRONESIA STATI FEDERATI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MIDWAY (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MOLDAVIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONACO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONGOLIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONTENEGRO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONTSERRAT',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MOZAMBICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MYANMAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NAMIBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NAURU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NEPAL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NICARAGUA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIGER',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIGERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIUE=SAVAGE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NORVEGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NUOVA CALEDONIA (ISOLE E DIPENDENZE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NUOVA ZELANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'OMAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAESI BASSI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PALAU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PANAMA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAPUA NUOVA GUINEA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PARAGUAY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PENON DE ALHUCEMAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PENON DE VELEZ DE LA GOMERA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PERU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PITCAIRN (E DIPENDENZE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'POLINESIA FRANCESE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'POLONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PORTOGALLO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PUERTO RICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'QATAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RAS AL KHAIMAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REGNO UNITO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA CECA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA DELLA CINA NAZIONALE=TAIWAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA DOMINICANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ROMANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RUANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RUSSIA=FEDERAZIONE RUSSA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAHARA OCCIDENTALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT BARTHELEMY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT LUCIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT MARTIN SETTENTRIONALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT PIERRE ET MIQUELON (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT VINCENT E GRENADINE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SALOMONE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAMOA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAMOA AMERICANE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAN MARINO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SANTELENA (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAO TOME E PRINCIPE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SEICELLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SENEGAL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SERBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SHARJAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SIERRA LEONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SINGAPORE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SINT MAARTEN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SIRIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SLOVACCHIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SLOVENIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SOMALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SPAGNA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SRI LANKA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'STATI UNITI DAMERICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUD GEORGIA E SUD SANDWICH ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUD SUDAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUDAFRICANA REPUBBLICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUDAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SURINAME',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVALBARD E JAN MAYEN ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVEZIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVIZZERA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SWAZILAND',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TAGIKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TANZANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORI PALESTINESI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORIO ANTARTICO FRANCESE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORIO BRITANNICO OCEANO INDIANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'THAILANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TIMOR ORIENTALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TOGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TOKELAU=ISOLE DELL UNIONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TONGA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TRINIDAD E TOBAGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TRISTAN DA CUNHA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TUNISIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURCHIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURKMENISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURKS E CAICOS (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TUVALU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UCRAINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UGANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UMM AL QAIWAIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UNGHERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'URUGUAY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UZBEKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VANUATU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VENEZUELA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VERGINI AMERICANE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VERGINI BRITANNICHE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VIETNAM',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'WAKE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'WALLIS E FUTUNA (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'YEMEN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ZAMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ZIMBABWE',
                jsonString: null,
                description: 'NAZIONE'
              }
            ],
            type: null
          },
          {
            name: 'PROVINCIA',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['word', 'required'],
            values: [
              {
                value: '',
                jsonString: null,
                description: ''
              },
              {
                value: 'AG',
                jsonString: null,
                description: 'AGRIGENTO'
              },
              {
                value: 'AL',
                jsonString: null,
                description: 'ALESSANDRIA'
              },
              {
                value: 'AN',
                jsonString: null,
                description: 'ANCONA'
              },
              {
                value: 'AO',
                jsonString: null,
                description: 'AOSTA'
              },
              {
                value: 'AP',
                jsonString: null,
                description: 'ASCOLI PICENO'
              },
              {
                value: 'AQ',
                jsonString: null,
                description: 'L AQUILA'
              },
              {
                value: 'AR',
                jsonString: null,
                description: 'AREZZO'
              },
              {
                value: 'AT',
                jsonString: null,
                description: 'ASTI'
              },
              {
                value: 'AV',
                jsonString: null,
                description: 'AVELLINO'
              },
              {
                value: 'BA',
                jsonString: null,
                description: 'BARI'
              },
              {
                value: 'BG',
                jsonString: null,
                description: 'BERGAMO'
              },
              {
                value: 'BI',
                jsonString: null,
                description: 'BIELLA'
              },
              {
                value: 'BL',
                jsonString: null,
                description: 'BELLUNO'
              },
              {
                value: 'BN',
                jsonString: null,
                description: 'BENEVENTO'
              },
              {
                value: 'BO',
                jsonString: null,
                description: 'BOLOGNA'
              },
              {
                value: 'BR',
                jsonString: null,
                description: 'BRINDISI'
              },
              {
                value: 'BS',
                jsonString: null,
                description: 'BRESCIA'
              },
              {
                value: 'BT',
                jsonString: null,
                description: 'BARLETTA ANDRIA TRANI'
              },
              {
                value: 'BZ',
                jsonString: null,
                description: 'BOLZANO'
              },
              {
                value: 'CA',
                jsonString: null,
                description: 'CAGLIARI'
              },
              {
                value: 'CB',
                jsonString: null,
                description: 'CAMPOBASSO'
              },
              {
                value: 'CE',
                jsonString: null,
                description: 'CASERTA'
              },
              {
                value: 'CH',
                jsonString: null,
                description: 'CHIETI'
              },
              {
                value: 'CL',
                jsonString: null,
                description: 'CALTANISSETTA'
              },
              {
                value: 'CN',
                jsonString: null,
                description: 'CUNEO'
              },
              {
                value: 'CO',
                jsonString: null,
                description: 'COMO'
              },
              {
                value: 'CR',
                jsonString: null,
                description: 'CREMONA'
              },
              {
                value: 'CS',
                jsonString: null,
                description: 'COSENZA'
              },
              {
                value: 'CT',
                jsonString: null,
                description: 'CATANIA'
              },
              {
                value: 'CZ',
                jsonString: null,
                description: 'CATANZARO'
              },
              {
                value: 'EN',
                jsonString: null,
                description: 'ENNA'
              },
              {
                value: 'FC',
                jsonString: null,
                description: 'FORLI CESENA'
              },
              {
                value: 'FE',
                jsonString: null,
                description: 'FERRARA'
              },
              {
                value: 'FG',
                jsonString: null,
                description: 'FOGGIA'
              },
              {
                value: 'FI',
                jsonString: null,
                description: 'FIRENZE'
              },
              {
                value: 'FM',
                jsonString: null,
                description: 'FERMO'
              },
              {
                value: 'FR',
                jsonString: null,
                description: 'FROSINONE'
              },
              {
                value: 'GE',
                jsonString: null,
                description: 'GENOVA'
              },
              {
                value: 'GO',
                jsonString: null,
                description: 'GORIZIA'
              },
              {
                value: 'GR',
                jsonString: null,
                description: 'GROSSETO'
              },
              {
                value: 'IM',
                jsonString: null,
                description: 'IMPERIA'
              },
              {
                value: 'IS',
                jsonString: null,
                description: 'ISERNIA'
              },
              {
                value: 'KR',
                jsonString: null,
                description: 'CROTONE'
              },
              {
                value: 'LC',
                jsonString: null,
                description: 'LECCO'
              },
              {
                value: 'LE',
                jsonString: null,
                description: 'LECCE'
              },
              {
                value: 'LI',
                jsonString: null,
                description: 'LIVORNO'
              },
              {
                value: 'LO',
                jsonString: null,
                description: 'LODI'
              },
              {
                value: 'LT',
                jsonString: null,
                description: 'LATINA'
              },
              {
                value: 'LU',
                jsonString: null,
                description: 'LUCCA'
              },
              {
                value: 'MB',
                jsonString: null,
                description: 'MONZA E DELLA BRIANZA'
              },
              {
                value: 'MC',
                jsonString: null,
                description: 'MACERATA'
              },
              {
                value: 'ME',
                jsonString: null,
                description: 'MESSINA'
              },
              {
                value: 'MI',
                jsonString: null,
                description: 'MILANO'
              },
              {
                value: 'MN',
                jsonString: null,
                description: 'MANTOVA'
              },
              {
                value: 'MO',
                jsonString: null,
                description: 'MODENA'
              },
              {
                value: 'MS',
                jsonString: null,
                description: 'MASSA CARRARA'
              },
              {
                value: 'MT',
                jsonString: null,
                description: 'MATERA'
              },
              {
                value: 'NA',
                jsonString: null,
                description: 'NAPOLI'
              },
              {
                value: 'NO',
                jsonString: null,
                description: 'NOVARA'
              },
              {
                value: 'NU',
                jsonString: null,
                description: 'NUORO'
              },
              {
                value: 'OR',
                jsonString: null,
                description: 'ORISTANO'
              },
              {
                value: 'PA',
                jsonString: null,
                description: 'PALERMO'
              },
              {
                value: 'PC',
                jsonString: null,
                description: 'PIACENZA'
              },
              {
                value: 'PD',
                jsonString: null,
                description: 'PADOVA'
              },
              {
                value: 'PE',
                jsonString: null,
                description: 'PESCARA'
              },
              {
                value: 'PG',
                jsonString: null,
                description: 'PERUGIA'
              },
              {
                value: 'PI',
                jsonString: null,
                description: 'PISA'
              },
              {
                value: 'PN',
                jsonString: null,
                description: 'PORDENONE'
              },
              {
                value: 'PO',
                jsonString: null,
                description: 'PRATO'
              },
              {
                value: 'PR',
                jsonString: null,
                description: 'PARMA'
              },
              {
                value: 'PT',
                jsonString: null,
                description: 'PISTOIA'
              },
              {
                value: 'PU',
                jsonString: null,
                description: 'PESARO URBINO'
              },
              {
                value: 'PV',
                jsonString: null,
                description: 'PAVIA'
              },
              {
                value: 'PZ',
                jsonString: null,
                description: 'POTENZA'
              },
              {
                value: 'RA',
                jsonString: null,
                description: 'RAVENNA'
              },
              {
                value: 'RC',
                jsonString: null,
                description: 'REGGIO CALABRIA'
              },
              {
                value: 'RE',
                jsonString: null,
                description: 'REGGIO EMILIA'
              },
              {
                value: 'RG',
                jsonString: null,
                description: 'RAGUSA'
              },
              {
                value: 'RI',
                jsonString: null,
                description: 'RIETI'
              },
              {
                value: 'RM',
                jsonString: null,
                description: 'ROMA'
              },
              {
                value: 'RN',
                jsonString: null,
                description: 'RIMINI'
              },
              {
                value: 'RO',
                jsonString: null,
                description: 'ROVIGO'
              },
              {
                value: 'SA',
                jsonString: null,
                description: 'SALERNO'
              },
              {
                value: 'SI',
                jsonString: null,
                description: 'SIENA'
              },
              {
                value: 'SO',
                jsonString: null,
                description: 'SONDRIO'
              },
              {
                value: 'SP',
                jsonString: null,
                description: 'LA SPEZIA'
              },
              {
                value: 'SR',
                jsonString: null,
                description: 'SIRACUSA'
              },
              {
                value: 'SS',
                jsonString: null,
                description: 'SASSARI'
              },
              {
                value: 'SU',
                jsonString: null,
                description: 'SUD SARDEGNA'
              },
              {
                value: 'SV',
                jsonString: null,
                description: 'SAVONA'
              },
              {
                value: 'TA',
                jsonString: null,
                description: 'TARANTO'
              },
              {
                value: 'TE',
                jsonString: null,
                description: 'TERAMO'
              },
              {
                value: 'TN',
                jsonString: null,
                description: 'TRENTO'
              },
              {
                value: 'TO',
                jsonString: null,
                description: 'TORINO'
              },
              {
                value: 'TP',
                jsonString: null,
                description: 'TRAPANI'
              },
              {
                value: 'TR',
                jsonString: null,
                description: 'TERNI'
              },
              {
                value: 'TS',
                jsonString: null,
                description: 'TRIESTE'
              },
              {
                value: 'TV',
                jsonString: null,
                description: 'TREVISO'
              },
              {
                value: 'UD',
                jsonString: null,
                description: 'UDINE'
              },
              {
                value: 'VA',
                jsonString: null,
                description: 'VARESE'
              },
              {
                value: 'VB',
                jsonString: null,
                description: 'VERBANO CUSIO OSSOLA'
              },
              {
                value: 'VC',
                jsonString: null,
                description: 'VERCELLI'
              },
              {
                value: 'VE',
                jsonString: null,
                description: 'VENEZIA'
              },
              {
                value: 'VI',
                jsonString: null,
                description: 'VICENZA'
              },
              {
                value: 'VR',
                jsonString: null,
                description: 'VERONA'
              },
              {
                value: 'VT',
                jsonString: null,
                description: 'VITERBO'
              },
              {
                value: 'VV',
                jsonString: null,
                description: 'VIBO VALENTIA'
              }
            ],
            type: null
          },
          {
            name: 'FISCALE',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['word', 'required'],
            flag: 'static_1',
            values: [
              {
                value: 'ABU DHABI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AFGHANISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AJMAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALAND ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALBANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ALGERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANDORRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANGOLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANGUILLA (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANTARTIDE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ANTIGUA E BARBUDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARABIA SAUDITA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARGENTINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARMENIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ARUBA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ASCENSION',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AUSTRALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AUSTRIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AZERBAIGIAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'AZZORRE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BAHAMAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BAHREIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BANGLADESH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BARBADOS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BELGIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BELIZE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BENIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BERMUDA (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BHUTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BIELORUSSIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOLIVIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BONAIRE SAINT EUSTATIUS AND SABA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOSNIA ED ERZEGOVINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOTSWANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BOUVET ISOLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BRASILE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BRUNEI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BULGARIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BURKINA FASO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'BURUNDI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAMBOGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAMERUN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CANADA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CANARIE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAPO VERDE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAROLINE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CAYMAN (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CENTRAFRICANA REPUBBLICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CEUTA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHAFARINAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHAGOS ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CHRISTMAS (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CIAD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CILE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CINA REPUBBLICA POPOLARE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CIPRO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CITTA DEL VATICANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CLIPPERTON',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COCOS (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COLOMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COMORE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CONGO REPUBBLICA DEMOCRATICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CONGO REPUBBLICA POPOLARE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COOK (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COREA DEL NORD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COREA DEL SUD',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COSTA DAVORIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'COSTA RICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CROAZIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CUBA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'CURACAO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DANIMARCA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DOMINICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'DUBAI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ECUADOR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'EGITTO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'EL SALVADOR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ERITREA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ESTONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ETIOPIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FAER OER (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FIGI=VITI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FILIPPINE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FINLANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FRANCIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'FUIJAYRAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GABON',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GAMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GEORGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GERMANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GHANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIAMAICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIAPPONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIBILTERRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIBUTI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GIORDANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GOUGH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GRECIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GRENADA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GROENLANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUADALUPA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUAM (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUATEMALA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUAYANA=GUIANA FRANCESE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUERNSEY ISOLE DEL CANALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA BISSAU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUINEA EQUATORIALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'GUYANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HAITI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HEARD E MCDONALD ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HONDURAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'HONG KONG',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'INDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'INDONESIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRAQ',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'IRLANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISLANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISOLE AMERICANE DEL PACIFICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ISRAELE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ITALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'JERSEY ISOLE DEL CANALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KAZAKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KENYA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KIRGHIZISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KIRIBATI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KOSOVO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'KUWAIT',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LA REUNION (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LAOS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LESOTHO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LETTONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LIECHTENSTEIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LITUANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'LUSSEMBURGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MACAO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MACEDONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MADAGASCAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MADEIRA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALAWI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALAYSIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALDIVE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALTA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MALVINE=FALKLAND (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAN (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARIANNE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAROCCO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARSHALL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MARTINICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAURITANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAURIZIO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MAYOTTE (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MELILLA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MESSICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MICRONESIA STATI FEDERATI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MIDWAY (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MOLDAVIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONACO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONGOLIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONTENEGRO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MONTSERRAT',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MOZAMBICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'MYANMAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NAMIBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NAURU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NEPAL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NICARAGUA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIGER',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIGERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NIUE=SAVAGE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NORVEGIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NUOVA CALEDONIA (ISOLE E DIPENDENZE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'NUOVA ZELANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'OMAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAESI BASSI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PALAU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PANAMA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PAPUA NUOVA GUINEA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PARAGUAY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PENON DE ALHUCEMAS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PENON DE VELEZ DE LA GOMERA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PERU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PITCAIRN (E DIPENDENZE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'POLINESIA FRANCESE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'POLONIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PORTOGALLO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'PUERTO RICO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'QATAR',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RAS AL KHAIMAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REGNO UNITO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA CECA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA DELLA CINA NAZIONALE=TAIWAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'REPUBBLICA DOMINICANA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ROMANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RUANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'RUSSIA=FEDERAZIONE RUSSA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAHARA OCCIDENTALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT BARTHELEMY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT LUCIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT MARTIN SETTENTRIONALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT PIERRE ET MIQUELON (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAINT VINCENT E GRENADINE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SALOMONE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAMOA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAMOA AMERICANE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAN MARINO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SANTELENA (ISOLA)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SAO TOME E PRINCIPE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SEICELLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SENEGAL',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SERBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SHARJAH',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SIERRA LEONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SINGAPORE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SINT MAARTEN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SIRIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SLOVACCHIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SLOVENIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SOMALIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SPAGNA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SRI LANKA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'STATI UNITI DAMERICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUD GEORGIA E SUD SANDWICH ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUD SUDAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUDAFRICANA REPUBBLICA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SUDAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SURINAME',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVALBARD E JAN MAYEN ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVEZIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SVIZZERA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'SWAZILAND',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TAGIKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TANZANIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORI PALESTINESI',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORIO ANTARTICO FRANCESE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TERRITORIO BRITANNICO OCEANO INDIANO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'THAILANDIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TIMOR ORIENTALE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TOGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TOKELAU=ISOLE DELL UNIONE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TONGA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TRINIDAD E TOBAGO',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TRISTAN DA CUNHA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TUNISIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURCHIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURKMENISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TURKS E CAICOS (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'TUVALU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UCRAINA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UGANDA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UMM AL QAIWAIN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UNGHERIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'URUGUAY',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'UZBEKISTAN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VANUATU',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VENEZUELA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VERGINI AMERICANE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VERGINI BRITANNICHE (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'VIETNAM',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'WAKE ISOLE',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'WALLIS E FUTUNA (ISOLE)',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'YEMEN',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ZAMBIA',
                jsonString: null,
                description: 'NAZIONE'
              },
              {
                value: 'ZIMBABWE',
                jsonString: null,
                description: 'NAZIONE'
              }
            ],
            type: null
          }
        ],
        status: [],
        errorMessage: []
      },
      {
        code: '15773',
        name: 'DOCUMENTO',
        bundleLink: null,
        bundleCode: null,
        position: 5,
        components: [
          {
            name: 'DATA_RILASCIO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['date.before.today', 'date', 'required'],
            values: [],
            type: null
          },
          {
            name: 'DATA_SCADENZA',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['date.after.today', 'date', 'required'],
            values: [],
            type: null
          },
          {
            name: 'DOCF_UPLOAD',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: null
          },
          {
            name: 'DOCR_UPLOAD',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: null
          },
          {
            name: 'ENTE_RILASCIO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['word', 'required'],
            values: [],
            type: null
          },
          {
            name: 'LUOGO_RILASCIO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required', 'city'],
            values: [],
            type: null
          },
          {
            name: 'NUMERO_DOCUMENTO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['alphanumeric', 'required'],
            values: [],
            type: null
          },
          {
            name: 'TIPO_DOCUMENTO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['word', 'required'],
            values: [],
            type: null
          }
        ],
        status: [],
        errorMessage: []
      }
      // },
      // {
      //   code: '16727',
      //   name: 'TITOLARE_ESERCITA',
      //   bundleLink: null,
      //   bundleCode: null,
      //   position: 6,
      //   components: [
      //     {
      //       name: 'LABEL',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: [],
      //       values: [],
      //       type: 'label'
      //     },
      //     {
      //       name: 'ESERCITA_SI',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'radio'
      //     },
      //     {
      //       name: 'ESERCITA_NO',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'radio'
      //     }
      //     // },
      //     // {
      //     //   name: 'ADD',
      //     //   id: 'bt-add',
      //     //   text: 'AGGIUNGI ALTRO TITOLARE',
      //     //   action: null,
      //     //   type: 'button',
      //     //   pullTo: 'left',
      //     //   active: true,
      //     //   status: [],
      //     //   errorMessage: [],
      //     //   validations: [],
      //     //   values: []
      //     // }
      //   ],
      //   status: [],
      //   errorMessage: []
      // }
    ]
  }
  return titolareEffettivo
}

export const getTitolareStaticComponent = () => {
  const TitolareStaticComponent = {
    widgets:[
      {
        code: '16727',
        name: 'TITOLARE_OWNER',
        bundleLink: null,
        bundleCode: null,
        position: 1,
        components: [
          {
            name: 'LABEL',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: 'label'
          },
          {
            name: 'EFFETTIVO_SI',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: ['selected'],
            type: 'radio'
          },
          {
            name: 'EFFETTIVO_NO',
            value: '',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: ['required'],
            values: [],
            type: 'radio'
          }
        ],
        status: [],
        errorMessage: []
      }
    ]
  }

  return TitolareStaticComponent

}



export const getTipDocValues = () => {

  return {
    Values: [
      { classe: 'A', descrizione: "Carta d'identità", enteEmissione: 'COMUNE', idBanca: '1', label: "Carta d'identita", nome: "Carta d'identita", rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: "Carta d'identita" },
      { classe: 'A', descrizione: 'Passaporto', enteEmissione: 'QUESTURA', idBanca: '1', label: 'Passaporto', nome: 'Passaporto', rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: 'Passaporto' },
      { classe: 'A', descrizione: 'Patente di guida', enteEmissione: 'UFFICIO PROVINCIALE MCTC', idBanca: '1', label: 'Patente di guida', nome: 'Patente di guida', rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: 'Patente di guida' }
    ]
  }
}



// WEBPACK FOOTER //
// ./state/static/titolareStatic.js